import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import ConsentGuard from './components/ConsentGuard';
import Login from './components/Login';
import Register from './components/Register';
import OnlineUsers from './components/OnlineUsers';
import PrivateChat from './components/PrivateChat';
import AdminPanel from './components/AdminPanel';
import ConsentPage from './components/ConsentPage';

const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div style={styles.container}>
        <div style={styles.loading}>Loading...</div>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/chat" replace />;
  }

  return children;
};

function App() {
  return (
    <AuthProvider>
      <Router basename={process.env.PUBLIC_URL || undefined}>
        <div className="App">
          <Routes>
            <Route 
              path="/login" 
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              } 
            />
            <Route 
              path="/register" 
              element={
                <PublicRoute>
                  <Register />
                </PublicRoute>
              } 
            />
            <Route
              path="/chat"
              element={
                <ProtectedRoute>
                  <ConsentGuard>
                    <OnlineUsers />
                  </ConsentGuard>
                </ProtectedRoute>
              }
            />
            <Route
              path="/chat-room/:roomId"
              element={
                <ProtectedRoute>
                  <ConsentGuard>
                    <PrivateChat />
                  </ConsentGuard>
                </ProtectedRoute>
              }
            />
            <Route
              path="/private-chat"
              element={
                <ProtectedRoute>
                  <ConsentGuard>
                    <PrivateChat />
                  </ConsentGuard>
                </ProtectedRoute>
              }
            />
            <Route 
              path="/consent" 
              element={
                <ProtectedRoute>
                  <ConsentPage />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/admin" 
              element={<AdminPanel />} 
            />
            <Route 
              path="/" 
              element={<Navigate to="/chat" replace />} 
            />
            <Route 
              path="*" 
              element={<Navigate to="/chat" replace />} 
            />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

const styles = {
  container: {
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loading: {
    fontSize: '18px',
    color: '#6b7280',
  },
};

export default App;
